import type { ISEOProps } from "../types/core";

export const PrivacyPolicyPageSEO: ISEOProps = {
  title: "Privacy Policy - Sugar Cribs",
  description:
    "Learn how Sugar Cribs protects your privacy and handles your personal information and data.",
};
